// SVG icons
const chatIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>`;
const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;
const sendIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>`;
const backIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>`;
const orderIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8v13H3V8"></path><path d="M1 3h22v5H1z"></path><path d="M10 12h4"></path></svg>`;
const faqIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>`;

// Customizable FAQ categories and answers
// You can easily modify this configuration
const faqConfig = {
  categories: [
    {
      id: "shipping",
      title: "Shipping & Delivery",
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>`,
      questions: [
        {
          q: "How long does shipping take?",
          a: "Standard shipping typically takes 3-5 business days within the country. International shipping can take 7-14 business days depending on your location."
        },
        {
          q: "Do you ship internationally?",
          a: "Yes, we ship to most countries worldwide. Shipping costs and delivery times vary depending on location."
        },
        {
          q: "How can I track my package?",
          a: "You can track your package using the tracking number provided in your shipping confirmation email or by using our order tracking tool."
        }
      ]
    },
    {
      id: "returns",
      title: "Returns & Refunds",
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 2v6h6M2.66 15.57a10 10 0 1 0 .57-8.38"/></svg>`,
      questions: [
        {
          q: "What is your return policy?",
          a: "We accept returns within 30 days of purchase. Items must be in original condition with tags attached."
        },
        {
          q: "How do I start a return?",
          a: "To start a return, log into your account, find your order, and click 'Return Items'. Then follow the instructions to print a return label."
        },
        {
          q: "When will I receive my refund?",
          a: "Once we receive your returned items, we'll process your refund within 3-5 business days. It may take an additional 5-10 days for the funds to appear in your account."
        }
      ]
    },
    {
      id: "products",
      title: "Product Information",
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>`,
      questions: [
        {
          q: "Are your products organic?",
          a: "Many of our products are organic, which will be clearly labeled on the product page. You can also use our filter to browse only organic products."
        },
        {
          q: "Where are your products made?",
          a: "Our products are sourced from various locations around the world. Each product page specifies the country of origin."
        },
        {
          q: "Do you offer warranty on products?",
          a: "Yes, most of our products come with a manufacturer's warranty. The warranty details are included on the product page."
        }
      ]
    }
  ]
};

// Chat Widget creation
function createChatWidget() {
  const container = document.getElementById('my-chatbot-container');
  if (!container) return;
  
  // Widget HTML
  container.innerHTML = `
    <div class="chat-widget">
      <button class="chat-button" id="open-chat" aria-label="Chat with us">${chatIcon}</button>
      <div class="chat-box" id="chat-box">
        <div class="chat-header">
          <span id="chat-header-title">How can I help you?</span>
          <button class="close-chat" id="close-chat" aria-label="Close">${closeIcon}</button>
        </div>
        <div class="chat-body" id="chat-body">
          <div class="chat-message">
            <div class="system-message">
              Hello! How can I assist you today?
            </div>
          </div>
          <div class="category-selector" id="category-selector">
            <button class="category-button" data-category="order">
              ${orderIcon} Track Your Order
            </button>
            <button class="category-button" data-category="faq">
              ${faqIcon} Frequently Asked Questions
            </button>
          </div>
        </div>
        <div class="chat-input" id="chat-input" style="display: none;">
          <input type="text" class="order-input" id="order-id" placeholder="Order Number" aria-label="Order Number">
          <button class="send-button" id="send-order">${sendIcon} Track</button>
        </div>
      </div>
    </div>
  `;
  
  // Select necessary elements
  const openChatBtn = document.getElementById('open-chat');
  const closeChatBtn = document.getElementById('close-chat');
  const chatBox = document.getElementById('chat-box');
  const chatHeaderTitle = document.getElementById('chat-header-title');
  const chatBody = document.getElementById('chat-body');
  const chatInput = document.getElementById('chat-input');
  const categorySelector = document.getElementById('category-selector');
  
  // Chat state
  let currentView = 'main'; // main, order, faq, faq-category
  let currentFaqCategory = null;
  
  // Widget open/close toggle function
  openChatBtn.addEventListener('click', (e) => {
    e.stopPropagation(); // Prevent event propagation
    
    // If widget is already open, close it
    if (chatBox.style.display === 'block') {
      closeChat();
    } else {
      // Otherwise, open it
      chatBox.style.display = 'block';
    }
  });
  
  // Close with X button
  closeChatBtn.addEventListener('click', (e) => {
    e.stopPropagation(); // Prevent event propagation
    closeChat();
  });
  
  // Chat close function
  function closeChat() {
    // Just hide without animation for now
    chatBox.style.display = 'none';
    
    // Reset to main view when closing
    if (currentView !== 'main') {
      resetToMainView();
    }
  }
  
  // Prevent clicks within chat widget from closing it
  document.querySelector('.chat-widget').addEventListener('click', (e) => {
    e.stopPropagation();
  });
  
  // Category selection
  document.querySelectorAll('.category-button').forEach(button => {
    button.addEventListener('click', () => {
      const category = button.getAttribute('data-category');
      if (category === 'order') {
        switchToOrderView();
      } else if (category === 'faq') {
        switchToFaqView();
      }
    });
  });
  
  // Enter key for order input
  document.getElementById('order-id').addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      document.getElementById('send-order').click();
    }
  });
  
  // Order tracking function
  document.getElementById('send-order').addEventListener('click', (e) => {
    e.stopPropagation(); // Prevent event propagation
    
    const orderId = document.getElementById('order-id').value.trim();
    if (!orderId) {
      addMessage('Please enter a valid order number.', 'system', true);
      return;
    }
    
    // Add user message - always show what the user typed
    addMessage(orderId, 'user');
    
    // Loading message
    const loadingMsgId = addMessage('<div class="loader"></div> Tracking your order...', 'system');
    
    // API request
    fetch('https://coracao.akillievotomasyon.com.tr/api/order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_id: orderId })
    })
    .then(res => res.json())
    .then(data => {
      // Always remove the loading message first
      const loadingMsg = document.getElementById(loadingMsgId);
      if (loadingMsg) {
        loadingMsg.remove();
      }
      
      if (data.error) {
        // Show error but keep the user's message visible
        addMessage(`<span class="error-message">${data.error}</span>`, 'system');
      } else {
        console.log(data);
        // Show order details
        let orderDetailsHTML = `
          <div>Thank you, ${data.name}! Here is order details:</div>
          <div class="order-details">
            <p><strong>Order Number:</strong> ${data.id}</p>
        `;
        
        // Add shipment status if available with status translations
        if (data.shipment_status) {
          let statusMessage = '';
          // Convert to uppercase for case-insensitive comparison
          const status = data.shipment_status.toUpperCase();

          switch(status) {
            case 'ATTEMPTED_DELIVERY':
              statusMessage = 'A delivery was attempted.';
              break;
            case 'CARRIER_PICKED_UP':
              statusMessage = 'The fulfillment has been picked up by the carrier.';
              break;
            case 'CONFIRMED':
              statusMessage = 'The fulfillment is confirmed.';
              break;
            case 'DELAYED':
              statusMessage = 'The fulfillment is delayed.';
              break;
            case 'DELIVERED':
              statusMessage = 'The fulfillment was successfully delivered.';
              break;
            case 'FAILURE':
              statusMessage = 'The fulfillment request failed.';
              break;
            case 'IN_TRANSIT':
              statusMessage = 'The fulfillment is in transit.';
              break;
            case 'LABEL_PRINTED':
              statusMessage = 'A purchased shipping label has been printed.';
              break;
            case 'LABEL_PURCHASED':
              statusMessage = 'A shipping label has been purchased.';
              break;
            case 'OUT_FOR_DELIVERY':
              statusMessage = 'The fulfillment is out for delivery.';
              break;
            case 'PICKED_UP':
              statusMessage = 'The fulfillment was successfully picked up.';
              break;
            case 'READY_FOR_PICKUP':
              statusMessage = 'The fulfillment is ready to be picked up.';
              break;
            default:
              statusMessage = data.shipment_status;
          }
          orderDetailsHTML += `
            <p><strong>Shipment Status:</strong> ${statusMessage}</p>
          `;
        }
        
        orderDetailsHTML += `
            <p><strong>Total Amount:</strong> $${data.total_price}</p>
        `;
        
        // Add tracking URL if available
        if (data.tracking_url) {
          orderDetailsHTML += `
            <p><strong>Track Shipment:</strong> <a href="${data.tracking_url}" target="_blank" class="tracking-link">${data.tracking_number}</a></p>
          `;
        }

        // Add order status URL if available
        if (data.order_status_url) {
          orderDetailsHTML += `
            <p><a href="${data.order_status_url}" target="_blank" class="view-order-btn">View Your Order</a></p>
          `;
        }
        
        orderDetailsHTML += `
            <p><strong>Products:</strong></p>
            <ul class="order-items">
              ${data.items.map(item => `<li>${item.title} (Qty: ${item.quantity})</li>`).join('')}
            </ul>
          </div>
        `;
        
        addMessage(orderDetailsHTML, 'system');
      }
      
      // Clear input
      document.getElementById('order-id').value = '';
    })
    .catch(err => {
      // Always remove the loading message first
      const loadingMsg = document.getElementById(loadingMsgId);
      if (loadingMsg) {
        loadingMsg.remove();
      }

      // Show error but keep the user's message visible
      addMessage('<span class="error-message">An error occurred. Please try again later.</span>', 'system');

      // Clear input
      document.getElementById('order-id').value = '';
      
      addMessage('<span class="error-message">An error occurred. Please try again later.</span>', 'system');
    });
  });
  
  // Switch to order tracking view
  function switchToOrderView() {
    currentView = 'order';
    chatHeaderTitle.textContent = 'Order Tracking';
    
    // Add user selection as a message
    addMessage('Track My Order', 'user');
    
    // Add system message
    addMessage('Please enter your order number to track your package', 'system');
    
    // Show input, hide categories
    categorySelector.style.display = 'none';
    chatInput.style.display = 'flex';
    
    // Set chat body height for order view
    document.getElementById('chat-body').style.height = '380px';
    
    // Focus on input
    setTimeout(() => {
      document.getElementById('order-id').focus();
    }, 300);
  }
  
  // Switch to FAQ view
  function switchToFaqView() {
    currentView = 'faq';
    chatHeaderTitle.textContent = 'FAQs';
    
    // Add user selection as a message
    addMessage('Frequently Asked Questions', 'user');
    
    // Hide categories and input
    categorySelector.style.display = 'none';
    chatInput.style.display = 'none';
    
    // Set chat body height for FAQ view
    document.getElementById('chat-body').style.height = '450px';
    
    // Create FAQ categories selector
    const faqHTML = `
      <div class="faq-categories">
        ${faqConfig.categories.map(category => `
          <button class="faq-category-button" data-category="${category.id}">
            ${category.icon} ${category.title}
          </button>
        `).join('')}
        <button class="back-button" id="back-to-main">
          ${backIcon} Back to Main Menu
        </button>
      </div>
    `;
    
    addMessage(faqHTML, 'system');
    
    // Add event listeners to FAQ category buttons - with a slight delay to ensure DOM is ready
    setTimeout(() => {
      document.querySelectorAll('.faq-category-button').forEach(button => {
        button.addEventListener('click', () => {
          const categoryId = button.getAttribute('data-category');
          showFaqCategory(categoryId);
        });
      });
      
      // Add event listener to back button
      const backBtn = document.getElementById('back-to-main');
      if (backBtn) {
        backBtn.addEventListener('click', resetToMainView);
      }
    }, 50);
  }
  
  // Show FAQ category
  function showFaqCategory(categoryId) {
    currentView = 'faq-category';
    currentFaqCategory = categoryId;
    
    // Find the selected category
    const category = faqConfig.categories.find(cat => cat.id === categoryId);
    if (!category) return;
    
    chatHeaderTitle.textContent = category.title;
    
    // Make sure FAQ height is maintained
    document.getElementById('chat-body').style.height = '450px';
    
    // Add user selection as a message
    addMessage(category.title, 'user');
    
    // Create FAQ questions list
    const questionsHTML = `
      <div class="faq-questions">
        ${category.questions.map(q => `
          <button class="faq-question-button" data-question="${q.q}">
            ${q.q}
          </button>
        `).join('')}
        <button class="back-button" id="back-to-faq">
          ${backIcon} Back to FAQ Categories
        </button>
      </div>
    `;
    
    addMessage(questionsHTML, 'system');
    
    // Add event listeners to question buttons with a delay
    setTimeout(() => {
      document.querySelectorAll('.faq-question-button').forEach(button => {
        button.addEventListener('click', () => {
          const question = button.getAttribute('data-question');
          showFaqAnswer(question, category);
        });
      });
      
      // Add event listener to back button
      const backBtn = document.getElementById('back-to-faq');
      if (backBtn) {
        backBtn.removeEventListener('click', switchToFaqView); // Remove any existing listeners
        backBtn.addEventListener('click', function() {
          // Simply reset to FAQ view manually - completely bypassing any existing listeners
          currentView = 'faq';
          chatHeaderTitle.textContent = 'FAQs';
          
          // Clear the chat except for first welcome message
          const chatBody = document.getElementById('chat-body');
          const firstMessage = chatBody.querySelector('.chat-message');
          
          chatBody.innerHTML = '';
          chatBody.appendChild(firstMessage);
          
          // Add "Frequently Asked Questions" message
          addMessage('Frequently Asked Questions', 'user');
          
          // Create FAQ categories selector
          const faqHTML = `
            <div class="faq-categories">
              ${faqConfig.categories.map(category => `
                <button class="faq-category-button" data-category="${category.id}">
                  ${category.icon} ${category.title}
                </button>
              `).join('')}
              <button class="back-button" id="back-to-main">
                ${backIcon} Back to Main Menu
              </button>
            </div>
          `;
          
          addMessage(faqHTML, 'system');
          
          // Add event listeners to FAQ category buttons
          setTimeout(() => {
            document.querySelectorAll('.faq-category-button').forEach(button => {
              button.addEventListener('click', () => {
                const categoryId = button.getAttribute('data-category');
                showFaqCategory(categoryId);
              });
            });
            
            // Add event listener to back button
            const backBtn = document.getElementById('back-to-main');
            if (backBtn) {
              backBtn.addEventListener('click', resetToMainView);
            }
          }, 50);
        });
      }
    }, 50);
  }
  
  // Show FAQ answer
  function showFaqAnswer(question, category) {
    // Add user question as message
    addMessage(question, 'user');
    
    // Find the answer
    const qa = category.questions.find(item => item.q === question);
    if (!qa) return;
    
    // Add the answer
    addMessage(qa.a, 'system');
    
    // Add "Ask another question" prompt
    const moreQuestionsHTML = `
      <div class="more-questions">
        <p>Would you like to ask another question?</p>
        <button class="back-button" id="ask-another-question">
          ${backIcon} Back to ${category.title}
        </button>
      </div>
    `;
    
    addMessage(moreQuestionsHTML, 'system');
    
    // Add event listener to the "ask another" button with delay
    setTimeout(() => {
      const askAnotherBtn = document.getElementById('ask-another-question');
      if (askAnotherBtn) {
        askAnotherBtn.addEventListener('click', function() {
          // Manually rebuild the category view
          currentView = 'faq-category';
          currentFaqCategory = category.id;
          
          chatHeaderTitle.textContent = category.title;
          
          // Clear chat except welcome message
          const chatBody = document.getElementById('chat-body');
          const firstMessage = chatBody.querySelector('.chat-message');
          
          chatBody.innerHTML = '';
          chatBody.appendChild(firstMessage);
          
          // Add user selection as a message
          addMessage(category.title, 'user');
          
          // Create FAQ questions list
          const questionsHTML = `
            <div class="faq-questions">
              ${category.questions.map(q => `
                <button class="faq-question-button" data-question="${q.q}">
                  ${q.q}
                </button>
              `).join('')}
              <button class="back-button" id="back-to-faq">
                ${backIcon} Back to FAQ Categories
              </button>
            </div>
          `;
          
          addMessage(questionsHTML, 'system');
          
          // Add event listeners to question buttons with a delay
          setTimeout(() => {
            document.querySelectorAll('.faq-question-button').forEach(button => {
              button.addEventListener('click', () => {
                const question = button.getAttribute('data-question');
                showFaqAnswer(question, category);
              });
            });
            
            // Add event listener to back button - with direct manual rebuild
            const backBtn = document.getElementById('back-to-faq');
            if (backBtn) {
              backBtn.addEventListener('click', function() {
                // Manually rebuild FAQ view
                currentView = 'faq';
                chatHeaderTitle.textContent = 'FAQs';
                
                // Clear the chat except for first welcome message
                const chatBody = document.getElementById('chat-body');
                const firstMessage = chatBody.querySelector('.chat-message');
                
                chatBody.innerHTML = '';
                chatBody.appendChild(firstMessage);
                
                // Add "Frequently Asked Questions" message
                addMessage('Frequently Asked Questions', 'user');
                
                // Create FAQ categories selector
                const faqHTML = `
                  <div class="faq-categories">
                    ${faqConfig.categories.map(category => `
                      <button class="faq-category-button" data-category="${category.id}">
                        ${category.icon} ${category.title}
                      </button>
                    `).join('')}
                    <button class="back-button" id="back-to-main">
                      ${backIcon} Back to Main Menu
                    </button>
                  </div>
                `;
                
                addMessage(faqHTML, 'system');
                
                // Add event listeners to FAQ category buttons
                setTimeout(() => {
                  document.querySelectorAll('.faq-category-button').forEach(button => {
                    button.addEventListener('click', () => {
                      const categoryId = button.getAttribute('data-category');
                      showFaqCategory(categoryId);
                    });
                  });
                  
                  // Add event listener to back button
                  const backBtn = document.getElementById('back-to-main');
                  if (backBtn) {
                    backBtn.addEventListener('click', resetToMainView);
                  }
                }, 50);
              });
            }
          }, 50);
        });
      }
    }, 50);
  }
  
  // Reset to main menu
  function resetToMainView() {
    currentView = 'main';
    currentFaqCategory = null;
    chatHeaderTitle.textContent = 'How can I help you?';
    
    // Reset chat body height to default
    document.getElementById('chat-body').style.height = '380px';
    
    // Clear chat except for first welcome message
    const chatBody = document.getElementById('chat-body');
    const firstMessage = chatBody.querySelector('.chat-message');
    
    chatBody.innerHTML = '';
    chatBody.appendChild(firstMessage);
    
    // Add category selector back
    chatBody.appendChild(categorySelector);
    categorySelector.style.display = 'flex';
    
    // Hide input
    chatInput.style.display = 'none';
  }
  
  // Add message to chat
  function addMessage(content, type, isError = false) {
    const chatBody = document.getElementById('chat-body');
    const messageId = 'msg-' + Date.now();
    
    const messageHTML = `
      <div class="chat-message ${type}-message" id="${messageId}">
        ${type === 'user' ? `<span>${content}</span>` : `<div class="system-message ${isError ? 'error-message' : ''}">${content}</div>`}
      </div>
    `;
    
    chatBody.insertAdjacentHTML('beforeend', messageHTML);
    chatBody.scrollTop = chatBody.scrollHeight;
    
    return messageId;
  }
  
  // Remove message
  function removeMessage(messageId) {
    const message = document.getElementById(messageId);
    if (message) {
      message.remove();
    }
  }
}

// Start widget
document.addEventListener('DOMContentLoaded', createChatWidget);

// If page is already loaded, create widget
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  createChatWidget();
}